module.exports = __webpack_public_path__ + "media/images/signup-ec136832eb70aef5f819473135d0cef4.svg";